import { styled, Switch } from '@mui/material';

export const StyledSwitch = styled(Switch)(() => ({
  padding: '0px',
  width: '40px',
  height: '20px',

  '& .MuiSwitch-switchBase': {
    padding: '0px',
  },

  '& .MuiSwitch-track': {
    borderRadius: '20px',
  },

  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: '16px',
    height: '16px',
    margin: '2px',
  },

  '& .Mui-focusVisible ~ .MuiSwitch-track': {
    opacity: '0.6',
  },
}));
